<template>
	<div class="userparam" :style="{ height: `${windowHeight}px`}">
		<el-card class="box-card" shadow="hover">
			<div slot="header" class="clearfix">
				<span>出入库参数</span><span style="color:#c8c7c4;font-size:10pt;">(自动保存)</span>
			</div>
			<el-row class="formTitle" v-if="!showerror">
			<el-col :span="3" v-for="(item,index) in storageparam" :key="index">
				<label for>
					<el-checkbox v-model="item.value" :true-label="1" :false-label="0" @change.native="val=>changebox(item.name,0)"></el-checkbox>
						<span>{{item.name}}</span>
				</label>
			</el-col>
		</el-row>
		<el-row v-if="showerror">
			<el-col :span="8" style="color:transparent">1</el-col>
			<el-col :span="8">暂无参数可设置</el-col>
			<el-col :span="8" style="color:transparent">1</el-col>
		</el-row>
		</el-card>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
export default {
	components: {
		
	},
	props: {
		
	},
	data() {
		return {
			windowHeight: window.innerHeight - 130,
			storageparam:[],
			showerror:false
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/user/userparam.scss');
		});
	},
	methods: {
		init(){
			var that=this;
			this.$apipost.get.GetInOutParam().then(res => {
				if(res.list!='')
					that.storageparam=res.list;
				if(that.storageparam.length==0)
					that.showerror=true;
				else	
					that.showerror=false;
			});
		},
		changebox(paramname,isvalue){
			var val=0;
			var filter=this.storageparam.filter(function(e) {
					return e.name==paramname;
				});
			if(filter.length>0){
				val=filter[0].value;
			}
			this.$apipost.post.SaveUserParam({value:val,showname:paramname,isvalue:isvalue}).then(res => {
				if(res.state=='1'){
					this.$tool.message('设置成功', 1);
				}else{
					this.$tool.message('设置失败',0);
				}
			});
		}
	}
}
		
</script>

<style>
</style>
